/*
|-------------------------------------------------------------------------------
| API modules/contact_us/index.js
|-------------------------------------------------------------------------------
| The Vuex data store for contact us
*/

import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import state from './state';

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
